import {
  Chip,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Iconify from "../iconify/Iconify";
import { fDateTime } from "src/utils/formatTime";
import { getStatusName } from "src/utils/inboxUtils";
import { getUserPermissions } from "src/utils/permissionsUtils";

const STATUS_COLORS = {
  Sent: "success",
  Sending: "warning",
  Scheduled: "info",
  Draft: "default",
};

export default function UserAdminInboxTable({ rows, userId }) {
  const navigate = useNavigate();
  const { isViewer } = getUserPermissions();

  if (!rows || rows.length === 0) {
    return (
      <Typography variant="body2" sx={{ color: "text.secondary", py: 2 }}>
        No messages have been created for this user yet.
      </Typography>
    );
  }

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} size="small">
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Publish Date</TableCell>
            <TableCell>Subject</TableCell>
            <TableCell>Read</TableCell>
            <TableCell>Status</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => {
            const status = getStatusName(row);
            return (
              <TableRow key={row.adminInboxMessageId}>
                <TableCell>{row.adminInboxMessageId}</TableCell>
                <TableCell>{fDateTime(row.publishAt)}</TableCell>
                <TableCell>{row.subject}</TableCell>
                <TableCell>{row.messagesReadCount ? "Yes" : "No"}</TableCell>
                <TableCell>
                  <Chip
                    label={status}
                    size="small"
                    color={STATUS_COLORS[status] ?? "default"}
                  />
                </TableCell>
                <TableCell align="right">
                  {!isViewer && (
                    <IconButton
                      size="small"
                      onClick={() =>
                        navigate(
                          `/dashboard/inbox/message?user_id=${userId}&message_id=${row.adminInboxMessageId}`
                        )
                      }
                    >
                      <Iconify icon="eva:edit-outline" />
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
